import { ReceiptPrinter } from "../ReceiptPrinter";
import {
  mapPrintApiConnectionType,
  mapPrintApiLanguage,
} from "../../shared/print-api/utils";
import { PrintApiPrinter } from "../../shared/print-api/types";
import { ReceiptLanguage } from "../enums";
import { PeripheralMetadata } from "../../shared/types";

export class PrintApiReceiptPrinter extends ReceiptPrinter {
  constructor(public device: PrintApiPrinter) {
    super(mapPrintApiConnectionType(device.connectionType));
  }

  // Override Peripheral getters to map from Print API service metadata
  get id(): string {
    return `print-api-${this.device.id}`;
  }

  override get name(): string {
    return this.device.name;
  }

  override get isConnected(): boolean {
    return false;
  }

  // Implement the metadata property from IPeripheral interface
  override get metadata(): PeripheralMetadata {
    return {
      address:
        this.device.metadata.macAddress || this.device.metadata.ipAddress,
      productId: this.device.metadata.productId,
      vendorId: this.device.metadata.vendorId,
      serialNumber: this.device.metadata.serialNumber || undefined,
      model: this.device.metadata.model || undefined,
      custom: this.device.metadata.custom || undefined,
    };
  }

  // Override ReceiptPrinter language getter to use Print API service metadata
  override get language(): ReceiptLanguage {
    return mapPrintApiLanguage(this.device.language);
  }

  // Connection methods (API printers don't actually connect/disconnect)
  override doConnect(): Promise<boolean> {
    return Promise.resolve(true);
  }

  override doDisconnect(): Promise<boolean> {
    return Promise.resolve(true);
  }

  // Receipt printer specific methods
  override print(_bytes: Uint8Array): Promise<boolean> {
    return Promise.resolve(true);
  }

  override popCashDrawer(): Promise<boolean> {
    return Promise.resolve(false);
  }
}
